<div class="responsive-container learnspace-theme" *ngIf="lsList">
  <div class="header">
    <div class="title programs-h4">My Programs</div>

    <div class="logo">
      <img src="{{hub.logo?.path}}">
    </div>

    <div class="right-elements">
      <div class="right-elements-row">
        <button mat-raised-button plan-limit color="primary" [canDo]="canCreateSpace()" (click)="addLearnspace()" [customTooltip]="'Upgrade to create new ' + (hub?.mode | spaceLabel:true)">
          <mat-icon fontSet="fa" fontIcon="fa-plus-circle"></mat-icon>
          NEW {{ hub?.mode | spaceLabel | uppercase }}
        </button>
      </div>
      <div class="right-elements-row">
        <mat-select *ngIf="listingMode !== 'latest'" class="sort-menu" (selectionChange)="sortList()" [(value)]="selectedSort">
          <mat-option *ngFor="let opt of sortOptions" [value]="opt.value"> {{ opt.name }}</mat-option>
        </mat-select>
      </div>
    </div>
  </div>

  <div class="programs-container">
    <!-- Empty list: create new program -->
    <div class="empty-hub-container" *ngIf="lsList && lsList.length === 0 && canCreateSpace()" (click)="addLearnspace()">
      CREATE A NEW {{ mode | spaceLabel | uppercase }}
      <mat-icon fontSet="fa" color="primary" fontIcon="fa-plus-circle"></mat-icon>
    </div>

    <!-- List of programs -->
    <list-of-programs
      [lsList]="lsList"
      [canCreateSpace]="canCreateSpace()"
      (addLearnspace)="addLearnspace()"
      (listUpdate)="countSpaces($event)"
    ></list-of-programs>
  </div>
</div>
